import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from 'vue';
    import { Tabs } from '@/components/ui/tabs';
    import type { Employee, SharedData } from '@/types';
    import { useEmployeeChangesData } from '@/composables/useEmployeeChangesData';
    import { useCompanyData } from '@/composables/useCompany';
    import { usePage } from '@inertiajs/vue3';
    import PersonalTab from './changes-tabs/PersonalTab.vue';
    import AddressTab from './changes-tabs/AddressTab.vue';
    import EmploymentTab from './changes-tabs/EmploymentTab.vue';
    import BankTab from './changes-tabs/BankTab.vue';
    import CompanyPensionTab from './changes-tabs/CompanyPensionTab.vue';
    import OptionalTab from './changes-tabs/OptionalTab.vue';
    import TerminationTab from './changes-tabs/TerminationTab.vue';
    import ChangedFieldsTab from './changes-tabs/ChangedFieldsTab.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeChangesTabs',
  props: {
    employee: {}
  },
  setup(__props: any) {

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const { companyData } = useCompanyData(selectedCompanyId.value);

    const props = __props;

    const company = computed(() => ({
        ...props.employee.company,
        ...companyData.value,
    }));

    const { employeeChangesData, isLoadingEmployeeChangesData } = useEmployeeChangesData(
        props.employee.id,
    );

    const hasUnnotedChanges = computed(() => {
        return (
            (props.employee.log && !props.employee.log.changes_noted) ||
            props.employee?.unnoted_salary
        );
    });

    const showOptional = computed(() => {
        if (isLoadingEmployeeChangesData.value) return false;

        const old = employeeChangesData.value?.optional?.old;
        if (!old) return false;

        const isset = (key: string) => old[key] !== undefined && old[key] !== null;

        return (
            isset('health_insurance') ||
            isset('diaeter') ||
            isset('kilometer') ||
            isset('has_pension') ||
            isset('danmarks_statistik') ||
            isset('has_free_car') ||
            isset('has_free_phone') ||
            isset('has_lunch_arrangement')
        );
    });

    const tabs = computed(() => {
        return [
            ...(hasUnnotedChanges.value
                ? [{ value: 'changes', label: 'employee.changed.header' }]
                : []),
            { value: 'personal', label: 'employee.personal.header' },
            { value: 'address', label: 'employee.address.header' },
            { value: 'employment', label: 'employee.employment.header' },
            { value: 'bank', label: 'employee.bank.header' },
            { value: 'pension', label: 'employee.pension.company_headline' },
            ...(showOptional.value
                ? [{ value: 'optional', label: 'employee.optional.header' }]
                : []),
            { value: 'termination', label: 'employee.termination.header' },
        ];
    });

    const currentTab = ref(hasUnnotedChanges.value ? 'changes' : 'personal');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Tabs), {
    tabs: tabs.value,
    modelValue: currentTab.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentTab).value = $event))
  }, _createSlots({
    personal: _withCtx(() => [
      _createVNode(PersonalTab, {
        employee: _ctx.employee,
        data: _unref(employeeChangesData)?.personal,
        optional: _unref(employeeChangesData)?.optional,
        company: company.value
      }, null, 8, ["employee", "data", "optional", "company"])
    ]),
    address: _withCtx(() => [
      _createVNode(AddressTab, {
        employee: _ctx.employee,
        data: _unref(employeeChangesData)?.address
      }, null, 8, ["employee", "data"])
    ]),
    employment: _withCtx(() => [
      _createVNode(EmploymentTab, {
        employee: _ctx.employee,
        data: _unref(employeeChangesData)?.employment,
        personalData: _unref(employeeChangesData)?.personal,
        oldEmployment: _unref(employeeChangesData)?.oldEmployment
      }, null, 8, ["employee", "data", "personalData", "oldEmployment"])
    ]),
    bank: _withCtx(() => [
      _createVNode(BankTab, {
        employee: _ctx.employee,
        data: _unref(employeeChangesData)?.bank
      }, null, 8, ["employee", "data"])
    ]),
    pension: _withCtx(() => [
      _createVNode(CompanyPensionTab, {
        employee: _ctx.employee,
        data: _unref(employeeChangesData)?.pension
      }, null, 8, ["employee", "data"])
    ]),
    termination: _withCtx(() => [
      _createVNode(TerminationTab, {
        employee: _ctx.employee,
        data: _unref(employeeChangesData)?.termination
      }, null, 8, ["employee", "data"])
    ]),
    _: 2
  }, [
    (hasUnnotedChanges.value)
      ? {
          name: "changes",
          fn: _withCtx(() => [
            _createVNode(ChangedFieldsTab, {
              employee: _ctx.employee,
              data: _unref(employeeChangesData)?.changedFields
            }, null, 8, ["employee", "data"])
          ]),
          key: "0"
        }
      : undefined,
    (showOptional.value)
      ? {
          name: "optional",
          fn: _withCtx(() => [
            _createVNode(OptionalTab, {
              employee: _ctx.employee,
              data: _unref(employeeChangesData)?.optional
            }, null, 8, ["employee", "data"])
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["tabs", "modelValue"]))
}
}

})